import React from 'react';

import { Link } from 'react-router-dom';

import { ROUTES } from '#/routes';

const Footer = () => (
    <div className='flex justify-between items-center bg-gray50 py-2 px-20'>
        <span className='font-inter text-sm font-normal text-gray400'>© 2025 Hill & Co. THE LIST</span>
        <div className='space-x-4 hidden md:block font-inter text-sm font-normal text-gray400'>
            <Link to={ROUTES.PRIVACY_POLICY} className='hover:underline cursor-pointer'>
                Privacy Policy
            </Link>
            <Link to={ROUTES.TERMS_AND_CONDITIONS} className='hover:underline cursor-pointer'>
                Terms & Conditions
            </Link>
            {/* <Link className='hover:underline'>Contact Us</Link> */}
        </div>
    </div>
);

export { Footer };
